export const API_BASEURL = process.env.REACT_APP_URL_API;
export const API_URL = process.env.REACT_APP_URL_API + '/api';